export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-shuffle-912aa6ad557cbb3e8f3aaf30c8e71584.svg";